import { diYu } from '../../../../../radish/src/constant/common-var'

export default {
  data: function() {
    return {
      tableHeads: [
        {
          label: '姓名',
          type: 'link',
          onClick: item => {
            this.clickName(item)
          },
          onClickSimi: item => {
            this.getSimi(item)
          },
        },
        {
          label: '操作',
          type: 'link',
          width: 30,
          content: '',
          icon: 'el-icon-setting',
          onClick: item => {
            if (item['手机']) {
              this.showAction(item)
            } else {
              this.$message.info('该人选为cc，请补全手机后操作')
            }
          },
        },
        {
          label: '线上沟通',
          type: 'link',
          onClick: item => {
            this.showFeedback(item)
          },
          editType: 'input',
        },
        { label: '发送状态' },
        { label: '圆手（小程序）', field: '圆手' },
        { label: '公众号', field: '公众号' },
        {
          label: '长意',
          field: '长期意向',
          type: 'select',
          width: 30,
          options: {
            Y: 'Y.积极看机会',
            N: 'N.暂时不看机会',
            F: 'F.再跟进',
          },
          colors: { Y: '#f99', N: '#ffc', F: '#ccf' },
          editType: 'select',
        },
        { label: '离职意愿度', field: '意愿度' },
        {
          label: '公司',
          type: 'link',
          onClick: item => {
            if (item['公司排名'] == '9999991') {
              app.root.$refs.radishEditCompany.show({ _id: item.rid, 公司: item['公司'] })
            } else {
              this.clickCompany(item['公司'])
            }
          },
          editType: 'input',
        },
        { label: '目前职位', editType: 'input' },
        {
          label: '手机',
          type: 'tooltip',
          width: 90,
          onMouseover: item => {
            if (item.手机 === '***') {
              this.getPhone(item.rid)
            }
          },
        },
        {
          label: '性别',
          width: 30,
          type: 'select',
          options: ['男', '女'],
          editType: 'select',
        },
        { label: '地域', type: 'tag', options: diYu, editType: 'createSelect' },
        { label: '职能模块', type: 'tag', width: 140 },
        { label: '擅长方向', type: 'tag', editType: 'multSelect' },
        { label: '细分职能', type: 'tag', editType: 'multSelect' },
        { label: '个性标签' },
        { label: '学历标签', type: 'tag' },
        { label: '学历' },
        {
          label: '职级',
          type: 'select',
          width: 40,
          options: {
            '1': '1.高管',
            '2': '2.部门总',
            '3': '3.部门副总/总助/团队长',
            '4': '4.部门核心骨干',
            '5': '5.新人三年以下',
          },
          editType: 'select',
        },
        {
          label: '业绩',
          type: 'select',
          width: 40,
          options: { aaa: 'aaa.领军人物', aa: 'aa.卓越人选', a: 'a.优秀人选', b: 'b.良好', c: 'c.一般', d: 'd.较差' },
          editType: 'select',
        },
        {
          label: '平台',
          type: 'select',
          width: 40,
          options: {
            A: 'A.大平台',
            B: 'B.中平台',
            C: 'C.小平台',
          },
          editType: 'select',
        },
      ],
    }
  },
}
